export default __webpack_public_path__ + "static/media/portfolio_export_arrow.d435f716.svg";